<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <div class="d-flex align-items-center row m-0 pb-1">
    <div class="col-5">
      <div class="margin-top-10"></div>
      <button class="btn btn-green btn-defBlue p-2 btn-ht btn-home"
        routerLink="/supplier-group">
        <span>
          <mat-icon svgIcon="home" alt="" class="pr-2"> </mat-icon>
        </span>
        <span class="float-right">
          ISA Home
        </span>
      </button>
    </div>
    <div class="center col-4"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
        class="logo-max-width" alt="edit"></div>
    <div class="col-3 top-right-button icon-align icon-align-adjust">
      <div class="row">
        <button class="home home-btn"
          routerLink="{{baseUrl2}}/supplier-group" title="Home" data-toggle="tooltip">
          <mat-icon svgIcon="home" width="17" height="15" alt="edit"
            class="icon-vertical-align"></mat-icon></button>
      </div>
    </div>
    <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
      <div class="row m-0 pb-2 pt-2 align-center">
        <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
          <h4 class="title">SEARCH in BvD Orbis database</h4>
        </div>
      </div>
      <div class="row m-0 align-center">
        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <label class="label-control" for="companyNameInput">Name<span class="element_astrick">*</span></label>
          <p class="border-right pr-4 m-0">
            <input id="companyNameInput" type="text" class="form-control form-control-sm" [(ngModel)]="companyNameModel"
              (keydown)="resetOtherFields('name')">
            <small class="float-right pr-4 search-close-btn" title="Clear"><button type="button"
                (click)="clearFields('companyNameModel')" class="btn-clear cancel">X</button></small>
            <span class="error-text" *ngIf="companyNameModelError==true">Please enter Company name</span>
          </p>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <label class="label-control" for="countryInput">Country<span class="element_astrick">*</span></label>
          <p class="border-right pr-4 m-0">
          <div class="form-control form-control-sm matformheight">
            <form class="form-width-325">
              <mat-form-field class="form-width-325">
                <input id="countryInput" class="form-wiidth-280" matInput aria-label="State"
                  (input)="onCountryInput($event, delayResCountry)" (keyup)="onItemKey($event)"
                  [matAutocomplete]="auto" [formControl]="delayResCountry">
                <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete autocomplete-display">
                  <ng-container *ngIf="CaptCountry.length > 0; else noResults">
                    <mat-option class="option-width-325" *ngFor="let value of CaptCountry"
                      (onSelectionChange)="onCountryeSelect(value)" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults>
                    <mat-option class="noResults" disabled *ngIf="siteCountryModel.length == 2 && !countryLoad1">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button type="button"
                  (click)="clearFields('siteCountryModel')" class="btn-clear cancel">X</button></small>
              <small class="float-right search-close-btn" *ngIf="countryLoad1"><img src="assets/images/loading.gif"
                  class="loadingheight" alt="Updating..."></small>
            </form>
          </div>
          <button type="button" class="float-right info-btn btn-info-custom cancel"
            title="info" data-toggle="modal" data-target="#dispCountryInfo"
            (click)="countryInfoModel()">
            <mat-icon svgIcon="info" class="info-icon-size"></mat-icon>
          </button>
          <span class="error-text" *ngIf="siteCountryModelError==true">Please select Country name</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <label class="label-control" for="cityInput">City</label>
          <p class="pr-4 m-0">
            <input id="cityInput" type="text" class="form-control form-control-sm" [disabled]="cityDisable==true"
              [(ngModel)]="siteCityModel" (ngModelChange)="siteCityModel = $event.toUpperCase()"
              (keydown)="resetOtherFields('name')" (keyup)="onItemKey($event)">
            <small class="float-right pr-4 search-close-btn" title="Clear"><button type="button"
                (click)="clearFields('siteCityModel')" class="btn-clear cancel">X</button></small>
          </p>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 text-right"
          *ngIf="superUserShow==false && roleVariableHide==false && showBuyerProfile==true && roleIsManager==false">
          <div class="label-control hidden"> &nbsp; </div>
          <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('All'))"> Clear All </button>
          <button type="button" [disabled]="DisableSearch" class="btn btn-custom btn-custom-lg btn-blue"
            (click)="ValidateMandarotyFields()"> Search </button>
        </div>
      </div>

      <div class="row m-0 ml-3 align-center"
        *ngIf="superUserShow==true || roleVariableHide==true || showBuyerProfile==false || roleIsManager==true">
        <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
        <span class="px-2 font-weight-bold">OR</span>
        <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
      </div>

      <div class="row m-0 align-center">
        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"
          *ngIf="superUserShow==true || roleVariableHide==true || showBuyerProfile==false || roleIsManager==true">
          <label class="label-control" for="identifierType">Identifier Type</label>
          <mat-select id="identifierType" class="border-right form-control form-control-sm dropdown-select"
            (selectionChange)="identifierValueChange($event)" [(ngModel)]="selectedIdentifierType"
            (ngModelChange)="onIdentifierTypeModelChange($event)" panelClass="dropdown-panel"
            [disableOptionCentering]="true">
            <mat-option value="bvdid" *ngIf="roleIsManager==false && showBuyerProfile==true">BvD ID</mat-option>
            <mat-option value="taxid">TAX ID</mat-option>
          </mat-select>
          <span class="error-text" *ngIf="selectedIdentifierError==true">Please enter the Identifier Type</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3" *ngIf="showCountrySelectForTaxId==true">
          <label class="label-control" for="countryTaxId">Country<span class="element_astrick">*</span></label>
          <p class="border-right pr-4 m-0">
          <div class="form-control form-control-sm matformheight">
            <form >
              <mat-form-field class="form-width-325">
                <input id="countryTaxId" class="form-width-280" matInput aria-label="State"
                  (input)="onCountryInput($event, delayResCountryDuo)" [matAutocomplete]="auto1"
                  [formControl]="delayResCountryDuo">
                <mat-autocomplete #auto1="matAutocomplete" [panelClass]="'min-width: 116%;'" class="custom-autocomplete autocomplete-display">
                  <ng-container *ngIf="CaptCountryForTaxId.length > 0; else noResults1">
                    <mat-option class="option-with-border" *ngFor="let value of CaptCountryForTaxId"
                      (onSelectionChange)="onCountryeSelectDuo(value)" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults1>
                    <mat-option class="noResults" disabled
                      *ngIf="siteCountryModelForTaxId.length >= 1 && !countryLoad2">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button type="button"
                  (click)="clearFields('siteCountryModelForTaxId')" class="btn-clear cancel" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('siteCountryModelForTaxId'))">X</button></small>
              <small class="float-right search-close-btn" *ngIf="countryLoad2"><img src="assets/images/loading.gif"
                  class="loadingheight" alt="Updating..."></small>
            </form>
          </div>
          <button type="button" class="float-right info-btn btn-info-custom cancel"
            title="info" data-toggle="modal" data-target="#dispCountryInfo"
            (click)="countryInfoModel()">
            <mat-icon svgIcon="info" class="info-icon-size"></mat-icon>
          </button>
          <span class="error-text" *ngIf="siteCountryModelErrorForIdens==true">Please select Country name</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"
          *ngIf="superUserShow==true || roleVariableHide==true || showBuyerProfile==false || roleIsManager==true">
          <label class="label-control" for="identifierValue">Identifier Value</label>
          <p class="pr-4 m-0">
            <input id="identifierValue" type="text" class="form-control form-control-sm" [disabled]="disableIdentifierInput==true"
              [(ngModel)]="IdentifierModel" (keydown)="resetOtherFields('bvdId')">
            <small class="float-right pr-4 search-close-btn" title="Clear"><button type="button"
                (click)="clearFields('IdentifierValueFLag')" class="btn-clear cancel">X</button></small>
            <span class="error-text" *ngIf="IdentifierModelError==true">Please enter the Identifier</span>
          </p>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"
          *ngIf="(superUserShow==true || roleVariableHide==true || showBuyerProfile==false || roleIsManager==true)
            && showCountrySelectForTaxId==false">
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 text-right"
          *ngIf="superUserShow==true || roleVariableHide==true || showBuyerProfile==false || roleIsManager==true">
          <div class="label-control hidden"> &nbsp; </div>
          <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('All'))"> Clear All </button>
          <button type="button" [disabled]="DisableSearch" class="btn btn-custom btn-custom-lg btn-blue"
            (click)="ValidateMandarotyFields()"> Search </button>
        </div>
      </div>
    </section>

    <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
      <div class="row m-0 pt-3 align-center">
        <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
          <h4 class="title">RESULTS <span *ngIf="loadData==true && data && data.length>=0">({{PageTotalLength}})</span>
          </h4>
        </div>

        <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
          <button type="button" [disabled]="radioImpSupplier"
            class="btn btn-green btn-custom-lg btn-blue float-right d-flex align-center" data-toggle="modal"
            data-target="#ImportSuppAdmin" (click)="CheckImportSupplierNew()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (CheckImportSupplierNew())">
            <mat-icon svgIcon="upload" class="img-btn upload-icon-size"></mat-icon><span
              class="float-right"> Import Selected Supplier </span>
          </button>
        </div>
      </div>

      <div class="row m-0">
        <div class="table-responsive mt-3">
          <div [ngClass]="{ 'fixTableHead' :loadData == true, 'fixTableFoot' :loadData == true}"
            [ngStyle]="pageHeightStyle()">
            <table class="table table-sm m-0">
              <thead>
                <tr>
                  <th class="ccwidth1"></th>
                  <th class="ccwidth2 th-text-left">Supplier Name</th>
                  <th class="ccwidth1b th-text-left">Status</th>
                  <th class="ccwidth1a th-text-left">Qualifiers</th>
                  <th class="ccwidth1 th-text-left">BvD ID</th>
                  <th class="ccwidth1 th-text-left">Country</th>
                  <th class="ccwidth1 th-text-left">City</th>
                  <th class="ccwidth2 th-text-left">Street</th>
                  <th class="ccwidth2 th-text-left">GUO</th>
                  <th class="ccwidth2 th-text-left">GUO BvD ID</th>
                </tr>
              </thead>

              <tbody *ngIf="loadData==true && data && data.length>=0" #customLoadingTemplate>
                <tr *ngFor="let cmData of data;let i=index">
                  <td *ngIf="!bvdSearch"> <span class="round-status"
                      [ngStyle]="{'background':rangeAlpha(cmData.MATCH[0]['SCORE'])['Clor'] }">
                        {{rangeAlpha(cmData.MATCH[0]['SCORE'])['Txt']}}</span>
                  </td>
                  <td *ngIf="bvdSearch"> <span class="round-status"
                      [ngStyle]="{'background':rangeAlpha(cmData.MATCH['SCORE'])['Clor'] }">
                        {{rangeAlpha(cmData.MATCH['SCORE'])['Txt']}}</span>
                  </td>
                  <td>
                    <span>
                      <input id="selectRow-{{cmData.BVD_ID_NUMBER}}" type="radio" [(ngModel)]="BvDnumber"
                        value="{{cmData.BVD_ID_NUMBER+'###'+cmData.GUO_BVD_ID_NUMBER+'###'+cmData.HQ_BVD_ID_NUMBER
                          +'###'+cmData.GUO_NAME+'###'+cmData.NAME+'###'+cmData.COUNTRY+'###'+cmData.CITY+'###'+cmData.POSTCODE}}"
                        (click)="enableRadio()" (keydown.enter)="enableRadio()" (keydown.space)="enableRadio()"
                        tabindex="0" name="ar1">
                    </span>
                    <label for="selectRow-{{cmData.BVD_ID_NUMBER}}" class="name">{{cmData.NAME}}</label>
                  </td>
                  <td><span *ngIf="cmData && cmData['STATUS'] && cmData['STATUS'][0]!=null" class="group-status"
                      [ngStyle]="{'background':getColorForStatus([cmData['STATUS'][0].toLowerCase()]) }">{{cmData['STATUS'][0]}}</span>
                  </td>
                  <td><mat-icon class="icon-size-27" *ngIf="cmData.CITY!=''"
                      svgIcon="P14"></mat-icon>&nbsp;&nbsp;<mat-icon
                      class="icon-size-27" *ngIf="cmData.HQ_BVD_ID_NUMBER==null"
                      svgIcon="P18"></mat-icon></td>
                  <td>{{cmData.BVD_ID_NUMBER}}</td>
                  <td>{{cmData.COUNTRY}}</td>
                  <td>{{this.apiService.hasNoSpecialCharacters(cmData.CITY_STANDARDIZED,cmData.CITY)}}</td>
                  <td>{{cmData.ADDRESS_LINE1}} {{cmData.ADDRESS_LINE2}} {{cmData.ADDRESS_LINE3}}</td>
                  <td>{{cmData.GUO_NAME}}</td>
                  <td>{{cmData.GUO_BVD_ID_NUMBER}}</td>
                </tr>
              </tbody>
              <tbody *ngIf="loadData == false && loading==false" #customLoadingTemplate>
                <tr>
                  <td colspan="10" class="font-weight-bold label-darkblue text-center"> No Results</td>
                </tr>
              </tbody>
              <tfoot *ngIf="data && data.length>0 && PageTotalLength>20">
                <tr>
                  <td colspan="10">
                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="BvDFilter('','','',1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (BvDFilter('','','',1,'cked'))">First</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="BvDFilter('','','',pager.currentPage - 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (BvDFilter('','','',pager.currentPage - 1,'cked'))">Previous</a>
                      </li>
                      <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="BvDFilter('','','',page,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (BvDFilter('','','',page,'cked'))">{{page}}</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="BvDFilter('','','',pager.currentPage + 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (BvDFilter('','','',pager.currentPage + 1,'cked'))">Next</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="BvDFilter('','','',pager.totalPages,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (BvDFilter('','','',pager.totalPages,'cked'))">Last</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <ng-container *ngIf="loading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </div>
  <div class="modal fade" id="ImportSuppAdmin" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-custom">
      <div class="modal-content modal-width-120">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
            Import a Supplier
            <button type="button" class="close" id="closeCCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h6>
        </div>

        <div class="modal-body" *ngIf="BE_Check==false">
          <section class="row m-0 bg-white no-shadow">
            <div class="section-width-20"></div>
            <div class="font-weight-bold section-width-50">BVD ID</div>
            <div class="section-width-20"></div>
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-center-items">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="font-weight-bold margin-left-165">GUO</span>
                <span>{{NL_GUO_BVD_ID_NUMBER}}</span>
                <img class="margin-right-195" alt="green-check1" src="assets/images/green-check1.png"
                  *ngIf="guoBvdCheck==false">
                <img class="margin-right-195" alt="gray-check1" src="assets/images/gray-check1.png"
                  *ngIf="guoBvdCheck==true">
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="font-weight-bold margin-left-170">HQ</span>
                <span>{{NL_HQ_BVD_ID_NUMBER}}</span>
                <img class="margin-right-195" alt="green-check1" src="assets/images/green-check1.png"
                  *ngIf="hqBvdCheck==false">
                <img class="margin-right-195" alt="gray-check1" src="assets/images/gray-check1.png"
                  *ngIf="hqBvdCheck==true">
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="font-weight-bold margin-left-165">SITE</span>
                <span>{{NL_BVD_ID_NUMBER}}</span>
                <img class="margin-right-195" alt="green-check1" src="assets/images/green-check1.png"
                  *ngIf="BE_Check==false">
                <img class="margin-right-195" alt="gray-check1" src="assets/images/gray-check1.png"
                  *ngIf="BE_Check==true">
              </div>
            </div>

            <div
              *ngIf="(loadingImpsupp==false && NL_Case_Occur!=1 && NL_Case_Occur!=2 && NL_Case_Occur!='') || grpDisp == true"
              class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div> <span class="weight-font"> GROUP</span> </div>
              <h6 class="h6Font"> {{ BvDdata.NAME ? BvDdata.NAME : '' }}</h6>
              <div *ngIf="GroupSelectDisab==true" class="label-control padLeft"> <span class="lfont">BvD ID :
                </span>{{ GroupBvDdetails.value ? GroupBvDdetails.value : '' }}</div>
              <div class="label-control padLeft">{{BvDdata['ADDRESS_LINE1'] ? BvDdata['ADDRESS_LINE1'] : '' }}</div>
              <div class="label-control padLeft">{{BvDdata['POSTCODE'] ? BvDdata['POSTCODE'] : '' }}
                {{this.apiService.hasNoSpecialCharacters(BvDdata['CITY_STANDARDIZED'],BvDdata['CITY']) }} </div>
              <div class="label-control padLeft">{{BvDdata['COUNTRY'] ? BvDdata['COUNTRY'] : '' }}</div>
              <div *ngIf="GroupSelectDisab==true" class="label-control padLeft"> <span class="lfont">Group Short Name
                  : </span>{{ GroupBvDdetails.shortNme ? GroupBvDdetails.shortNme : '' }}</div>
              <div *ngIf="GroupSelectDisab==true" class="label-control padLeft"> <span class="lfont">Group Category :
                </span>{{this.groupCategoryModel}} </div>
              <div *ngIf="GroupSelectDisab==true" class="label-control padLeft"><span class="lfont">Group ID :
                </span>{{GroupBvDdetails['groupAllianceIdentifier'] ? GroupBvDdetails['groupAllianceIdentifier'] : ''
                }}</div>


              <div *ngIf="GroupSelectDisab==false" class="label-control padLeft">
                <label for="groupShortName">Group Short Name<span class="element_astrick">*</span>:</label>
                <input type="text" maxlength="6" autocomplete="off" id="groupShortName"
                  class="form-control2 form-control-sm selsty4 form-control-paddings"
                  [disabled]="disableGrpShortNameLoad==true || grpDisp" [(ngModel)]="groupShortName"
                  (ngModelChange)="checkvalidateGroupShortNameField($event)">
                <span class="ng-clear-wrapper BvDclear" *ngIf="disableGrpShortNameLoad==false" title="Clear">
                  <button class="ng-clear cancel clr"
                    (click)="resetGroupShortNameFields()"
                    (keydown.enter)="resetGroupShortNameFields()"
                    (keydown.space)="resetGroupShortNameFields()" tabindex="0">×</button></span>
                <span class="shortNameError" *ngIf="groupShortNameError==true">Please enter group short name</span>
                <span class="shortNameError" *ngIf="groupShortNameRegExError==true">Please enter alphanumerical
                  value</span>
                <span class="shortNameError" *ngIf="groupShortNameExistsError==true">Already Exists !! Try
                  another</span>
              </div>
              <div *ngIf="GroupSelectDisab==false" class="label-control padLeft">Group Category<span
                  class="element_astrick">*</span> :
                <mat-select class="form-control2 form-control-sm selsty4 grpCatSelect form-control-paddings"
                  [(ngModel)]="groupCategoryModel" (SelectionChange)="checkvalidateGroupCategoryField()"
                  panelClass="dropdown-panel" [disableOptionCentering]="true" [disabled]="GroupSelectDisab || grpDisp">
                  <mat-option *ngFor="let groupCategory of groupCategories"
                    [value]="groupCategory.row_id">{{groupCategory.groupTypeCode}}</mat-option>
                </mat-select>
                &nbsp;<span class="shortNameError1" *ngIf="groupCategoryModelError==true">Please select group
                  category</span>
              </div>
            </div>

            <div
              *ngIf="(loadingImpsupp==false && NL_Case_Occur!=1 && NL_Case_Occur!='' && GroupSelectDisab==false)
                || CompanySelectDisab==false"
              class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div> <span class="weight-font"> COMPANY</span> </div>
              <div class="radio-group radio-padding">
                <div class="form-check">
                  <input id="companyTypeBop" type="radio" [(ngModel)]="typeName" value="bop" (change)="c2bValueDisplay()"
                    class="form-check-input radio-size">
                  <label class="form-check-label label-padding" for="companyTypeBop">BOP</label>
                </div>
                <div class="form-check">
                  <input id="companyTypeNbop" type="radio" [disabled]="roleVariableHide == false && superUserShow == false"
                    [(ngModel)]="typeName" value="nbop" (change)="c2bValueDisplay()" class="form-check-input radio-size">
                  <label class="form-check-label label-padding" for="companyTypeNbop">NBOP</label>
                </div>
                <div class="form-check">
                  <input id="companyTypeFinance" type="radio" [disabled]="roleVariableHide == false && superUserShow == false"
                    [(ngModel)]="typeName" value="finance" (change)="c2bValueDisplay()" class="form-check-input radio-size">
                  <label class="form-check-label label-padding" for="companyTypeFinance">FINANCE</label>
                </div>
              </div>
            </div>

            <div *ngIf="typeName=='nbop' && C2bDisplay"
              class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div> <span class="weight-font"> SITES</span> </div>
              <input id="c2bCheckbox" type="checkbox" maxlength="10" (click)="c2bCheck()"
                (keydown.enter)="c2bCheck()" (keydown.space)="c2bCheck()" [(ngModel)]="c2bValue" autocomplete="off">
              <label for="c2bCheckbox">C2B:</label>
              <input id="c2bName" type="text" maxlength="10" class="form-control2 form-control-sm selsty4 form-control-paddings"
                [disabled]="!c2bValue" [(ngModel)]="c2bName" (ngModelChange)="checkvalidatec2b($event)">
              <span class="shortNameError" *ngIf="c2bError==true">C2B Code Already Exists!</span>
              <span *ngIf="loadingC2b" class="loading-container loading-center">
                <img src="assets/images/loading.gif" alt="loading...">
              </span>
            </div>

            <span *ngIf="loadingImpsupp==true" class="text-center-align">L o a d i n g >> G R O U P . . .</span>
            <span *ngIf="loadingImpsupp==true"><img src="assets/images/loading.gif" alt="loading..."></span>
            <div *ngIf="loadingImpsupp==true || loadingImpsupp2==true || loadingImpsupp3 == true">
              <span class="pl-5 font-weight-bold success-text" *ngIf="groupCurrentStatus!='BvD interface API error (Timeout)'">
                {{groupCurrentStatus}}
              </span>
              <span class="pl-5 font-weight-bold error-text" *ngIf="groupCurrentStatus=='BvD interface API error (Timeout)'">
                {{groupCurrentStatus}}
              </span>
            </div>
            <ng-container *ngIf="loadingImpsupp">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </section>
          <section *ngIf="importSuppStep2==true && loadingImpsupp==false" class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div>
                <span class="weight-font"> COMPANY </span>
              </div>
              <div *ngIf="loadingImpsupp2==false" class="flex-width-50-left">
                <h6 class="h6Font"> {{NL_BvDdataCnS.NAME}}</h6>
                <div class="label-control padLeft"><span class="lfont">BvD ID :
                  </span>{{NL_BvDdataCnS.BVD_ID_NUMBER}}</div>
                <div *ngIf="loadCompanySection==true" class="label-control padLeft">{{NL_BvDdataCnS['ADDRESS_LINE1'] ?
                  NL_BvDdataCnS['ADDRESS_LINE1'] : '' }}</div>
                <div *ngIf="loadCompanySection==true" class="label-control padLeft">{{NL_BvDdataCnS['POSTCODE'] ?
                  NL_BvDdataCnS['POSTCODE'] : '' }}
                  {{this.apiService.hasNoSpecialCharacters(NL_BvDdataCnS['CITY_STANDARDIZED'],NL_BvDdataCnS['CITY'])
                  }}</div>
                <div *ngIf="loadCompanySection==true" class="label-control padLeft">{{NL_BvDdataCnS['COUNTRY'] ?
                  NL_BvDdataCnS['COUNTRY'] : '' }}</div>
                <div *ngIf="loadCompanySection==true" class="label-control padLeft"><span class="lfont">Company ID :
                  </span>{{companyInfos.companyAllianceIdentifier}}</div>
              </div>
              <span *ngIf="loadingImpsupp2==true" class="text-center-align">L o a d i n g >> C O M P A N Y . .
                .</span>
              <span *ngIf="loadingImpsupp2==true"><img src="assets/images/loading.gif" alt="loading..."></span>
              <ng-container *ngIf="loadingImpsupp2">
                <div class="local-loading-overlay">
                  <div class="custom-spinner-template">
                    <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                  </div>
                </div>
              </ng-container>
            </div>
          </section>
          <section *ngIf="importSuppStep3==true" class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div *ngIf="NL_flagSite_step3Init==true">
                <span class="weight-font"> SITE </span>
              </div>
              <span *ngIf="loadingImpsupp3==false && SitesInfo">
                <h6 class="h6Font2"> {{ SitesInfo.NAME }} {{SitesInfo.CITY}} </h6>
                <div *ngIf="NL_flagSite_step3Init==true && SitesInfo?.BVD_ID_NUMBER" class="label-control padLeft">
                  <span class="lfont">BvD ID : </span>{{SitesInfo.BVD_ID_NUMBER}}</div>
                <div *ngIf="loadSiteSection==true" class="label-control padLeft">{{SitesInfo['ADDRESS_LINE1'] ?
                  SitesInfo['ADDRESS_LINE1'] : '' }}</div>
                <div *ngIf="loadSiteSection==true" class="label-control padLeft">{{SitesInfo['POSTCODE'] ?
                  SitesInfo['POSTCODE'] : '' }}
                  {{this.apiService.hasNoSpecialCharacters(SitesInfo['CITY_STANDARDIZED'],SitesInfo['CITY']) }}</div>
                <div *ngIf="loadSiteSection==true" class="label-control padLeft">{{SitesInfo['COUNTRY'] ?
                  SitesInfo['COUNTRY'] : '' }}</div>
                <div *ngIf="loadSiteSection==true" class="label-control padLeft"><span class="lfont">Site ID :
                  </span>{{ SitesInfo.identifier }}</div>
              </span>
              <span *ngIf="loadingImpsupp3==true" class="text-center-align">L o a d i n g >> S I T E . . .</span>
              <ng-container *ngIf="loadingImpsupp3">
                <div class="local-loading-overlay">
                  <div class="custom-spinner-template">
                    <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                  </div>
                </div>
              </ng-container>
        </div>
          </section>
        </div>
        <div class="modal-body" *ngIf="BE_Check==true">
          This Supplier is already available in ISA
          <div *ngFor="let data of cmpDetails" class="display-flex-space-between">
            <span>{{data.id}}</span>
            <mat-icon svgIcon="speechcomment" alt="copy" (onSelectionChange)="copyToClipboard(data.id)"
              [matTooltip]="'Copy'" [ngStyle]="{'cursor': 'pointer'}" [matTooltipPosition]="'above'"></mat-icon>
            <b class="padding-left-8"><a data-dismiss="modal" [routerLink]="['/company-details',data.rowId]">
                {{data.name}}</a></b>
          </div>
        </div>
        <div class="modal-body" *ngIf="NullCheck==true">
          Importation process cannot proceed further!
        </div>
        <div class="pl-5 font-weight-bold error-text" *ngIf="checkForStopOrContinue==true && BE_Check==false">
          Please Contact isa&#64;renault.com
        </div>
        <div class="modal-footer border-0" *ngIf="BE_Check==false && ImportDone==false && checkForStopOrContinue==false"
          [ngClass]="{'displayNone' : nextBtnNotVisible==true}">
          <section class="bg-white no-shadow m-0">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" id="btnForNextt" class="btn btn-custom btn-custom-sm btn-blue"
              (click)="ImportCheckNextNew()"
              [disabled]="siteDisableNext==false ? siteDisableNext : (disableNext || groupShortName=='' || groupCategoryModel=='')">
              {{importNextButt}}
            </button>
          </section>
        </div>
        <div class="modal-footer border-0" *ngIf="BE_Check==true || ImportDone==true">
          <section class="row m-0 bg-white no-shadow">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
              (click)="redirectToCompanyDetails()"> Close </button>
          </section>
        </div>
        <div class="modal-footer border-0" *ngIf="checkForStopOrContinue==true && BE_Check==false">
          <section class="row m-0 bg-white no-shadow">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade mt-4" id="dispCountryInfo" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-custom">
      <div class="modal-content modal-width-500">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel3">
            Countries
            <button type="button" class="close" id="closeDispCountryInfo" #closeBtn data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h6>
        </div>
        <div class="modal-body row m-0 p-0 table-responsive modal-height-300">
          <table class="table m-0">
            <thead class="bg-f5f5f5">
              <tr class="col p-0">
                <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom1"
                  (click)="sort('countryFlag')" (keydown.enter)="sort('countryFlag')"
                  (keydown.space)="sort('countryFlag')">Flag</th>
                <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom1"
                  (click)="sort('countryCode')" (keydown.enter)="sort('countryCode')"
                  (keydown.space)="sort('countryCode')">Code</th>
                <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom1"
                  (click)="sort('countryName')" (keydown.enter)="sort('countryName')"
                  (keydown.space)="sort('countryName')">Name</th>
              </tr>
            </thead>
            <tbody *ngIf="dataForDispCountryInfo.length>0">
              <tr *ngFor="let dats of dataForDispCountryInfo; let i = index" class="col forColor p-0">
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold"><img
                    src="{{dats.flag}}" alt="info"></td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{dats.countryCode}}
                </td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{dats.countryName}}
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="dataForDispCountryInfo.length==0">
              <tr>
                <td colspan="7" class="font-weight-bold label-darkblue text-center">No Results</td>
              </tr>
            </tbody>
            <ng-container *ngIf="countryInfoLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </table>
        </div>
        <div class="modal-footer border-0 row">
          <section class="bg-white no-shadow m-0 row">
            <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
              id="closeDispCountryInfo1">
              Close
            </button>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="showSelectCountryId" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-custom">
      <div class="modal-content modal-margin-left-9">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
            Select Country
            <button type="button" class="close" id="closeshowSelectCountryId" #closeBtn data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h6>
        </div>

        <div class="modal-body">
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <mat-select class="form-control form-control-sm dropdown-select" name="countrySelect" id=""
                [(ngModel)]="selectedCustomCountry" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="{{coun}}" *ngFor="let coun of countrySelList">{{coun}}</mat-option>
              </mat-select>
            </div>
          </section>
        </div>

        <div class="modal-footer border-0">
          <section class="bg-white no-shadow m-0">
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
              (click)="checkSelRunSite()"> OK </button>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="showWarningErrMsg" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-custom">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
            Warning
            <button type="button" class="close" id="closeShowWarningErrMsg" #closeBtn data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h6>
        </div>

        <div class="modal-body">
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="label-control label-font-14-bold">
                There is a technical issue, please try later!
              </div>
            </div>
          </section>
        </div>

        <div class="modal-footer border-0">
          <section class="bg-white no-shadow m-0">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Ok </button>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="display-none">
    <button id="btnForSelectCountryId" data-target="#showSelectCountryId" data-toggle="modal"></button>
    <button id="btnWarningTechErr" data-target="#showWarningErrMsg" data-toggle="modal"></button>
  </div>
</div>